import Paper from '@mui/material/Paper';
import EditUser from './components/EditUser';
import './app.css';

function App() {
    return (
        <Paper sx={{ minHeight: 'full' }}>
            <EditUser />
        </Paper>
    );
}

export default App;
